


























import { computed, defineComponent } from '@nuxtjs/composition-api'
import Footer from '~/components/car/classifieds/form/footer/Footer.vue'
import ContactInfoFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/ContactInfoFieldsetHandler.vue'
import CategoryFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/CategoryFieldsetHandler.vue'
import PhotosFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/PhotosFieldsetHandler.vue'
import VehicleDetailsFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/VehicleDetailsFieldsetHandler.vue'
import LeasingFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/LeasingFieldsetHandler.vue'
import OfferInfoFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/OfferInfoFieldsetHandler.vue'
import TradesFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/TradesFieldsetHandler.vue'
import DescriptionFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/DescriptionFieldsetHandler.vue'
import OnlineFinancingFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/OnlineFinancingFieldsetHandler.vue'
import CertificatesFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/CertificatesFieldsetHandler.vue'
import DefaultFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/DefaultFieldsetHandler.vue'
import { CLASSIFIED_FORM_NS } from '~/store/modules/shared/classifieds/form/state'
import { useNamespacedStore } from '~/compositions/store'
import FinancingFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/FinancingFieldsetHandler.vue'
import PersonalNotesFieldsetHandler from '~/components/car/classifieds/form/fieldsets/handlers/PersonalNotesFieldsetHandler.vue'

export default defineComponent({
  components: {
    Footer,
    ContactInfoFieldsetHandler,
    CategoryFieldsetHandler,
    PhotosFieldsetHandler
  },
  setup() {
    const { state, getters } = useNamespacedStore(CLASSIFIED_FORM_NS)

    const fieldsets = computed(() => state.fieldsets || [])
    const pageKey = computed(() => state.pageKey)
    const invalidTriggered = computed(() => state.invalidTriggered)
    const onlyDealersAllowedGuard = computed(() =>
      getters('onlyDealersAllowedGuard')
    )

    const fieldsetsToShow = computed(() => {
      if (onlyDealersAllowedGuard.value) {
        return fieldsets.value.filter(f => f.name === 'category')
      }
      return fieldsets.value
    })

    const showFooter = computed(() => {
      return !onlyDealersAllowedGuard.value && fieldsetsToShow.value.length
    })

    const getFieldsetComponent = (name: string) => {
      switch (name) {
        case 'contact_info': {
          return ContactInfoFieldsetHandler
        }
        case 'category': {
          return CategoryFieldsetHandler
        }
        case 'media':
        case 'photos': {
          return PhotosFieldsetHandler
        }
        case 'vehicle_details': {
          return VehicleDetailsFieldsetHandler
        }
        case 'leasing': {
          return LeasingFieldsetHandler
        }
        case 'offer_info':
        case 'offer_details': {
          return OfferInfoFieldsetHandler
        }
        case 'financing': {
          return FinancingFieldsetHandler
        }
        case 'online_finance':
        case 'online_financing': {
          return OnlineFinancingFieldsetHandler
        }
        case 'trades': {
          return TradesFieldsetHandler
        }
        case 'description': {
          return DescriptionFieldsetHandler
        }
        case 'certificates': {
          return CertificatesFieldsetHandler
        }
        case 'notes': {
          return PersonalNotesFieldsetHandler
        }
        default: {
          return DefaultFieldsetHandler
        }
      }
    }

    return {
      getFieldsetComponent,
      showFooter,
      fieldsetsToShow,
      fieldsets,
      pageKey,
      invalidTriggered
    }
  }
})
